import { Box } from '@mui/material'
import React from 'react'
import { useAtom } from 'infrastructure/state/jotai.wrapper'
import { lessonMappingTreesAtom } from 'domains/scope-and-sequence/features/lesson-mappings/atoms'
import { TreeSelectWithList } from 'domains/scope-and-sequence/components'

export function LessonPoolDetails() {
  const [allTrees, setAllTrees] = useAtom(lessonMappingTreesAtom)
  return (
    <Box>
      <Box padding="5px" color="text.secondary">
        Add up to 3 curriculum trees to pull lessons from. The tool will
        automatically match lessons from these trees to the standards in your
        pacing guide.
      </Box>
      <Box>
        <TreeSelectWithList
          currentTrees={allTrees}
          setCurrentTrees={setAllTrees}
        />
      </Box>
    </Box>
  )
}
